module.exports = "/shiftTasks/components/modals/viewTaskTemplate-6b6d59.html";